import { render, staticRenderFns } from "./Transacciones.vue?vue&type=template&id=0ca1a0b2&scoped=true&"
import script from "./Transacciones.vue?vue&type=script&lang=js&"
export * from "./Transacciones.vue?vue&type=script&lang=js&"
import style0 from "./Transacciones.vue?vue&type=style&index=0&id=0ca1a0b2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ca1a0b2",
  null
  
)

export default component.exports